import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { autosaveDraft } from '../../action/autosave/autosave-draft';
import { clearAutosavedDraft } from '../../action/autosave/clear-autosaved-draft';
import { draftCommentForEmployeeSelector } from '../../reducers/autosave-selectors';
import { deleteComment } from '../actions/delete-comment';
import { editComment } from '../actions/edit-comment';
import { loadEmployeeComments } from '../actions/load-comments';
import { saveComment } from '../actions/save-comment';
import { commentsForIdSelector, commentsStateForEmployeeIdSelector } from '../comment-selectors';

import { EmployeeCommentTemplates } from '../../comment-template/components/employee-comment-templates';

import { CommentList } from './comment-list';

import { AUTOSAVED_DRAFT_TYPES } from '../../util/autosaved-draft-types';

const mapStateToProps = (state: any, { employeeId }: InputProps) => ({
  commentDraft: draftCommentForEmployeeSelector(state, employeeId),
  comments: commentsForIdSelector(state, employeeId, 'employee'),
  commentsState: commentsStateForEmployeeIdSelector(state, employeeId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  { employeeId }: InputProps,
) => ({
  actions: {
    saveComment: (comment: string) => dispatch(saveComment({ employeeId }, comment)),
    editComment: (commentId: number, comment: string) =>
      dispatch(editComment({ employeeId }, commentId, comment)),
    deleteComment: (commentId: number) => dispatch(deleteComment({ employeeId }, commentId)),
    loadComments: () => dispatch(loadEmployeeComments({ employeeId })),
    clearSavedDraft: () =>
      dispatch(clearAutosavedDraft(AUTOSAVED_DRAFT_TYPES.COMMENT, { employeeId })),
    autosaveDraft: (messageBody: string, commentId?: number) =>
      dispatch(
        autosaveDraft(AUTOSAVED_DRAFT_TYPES.COMMENT, {
          context: { employeeId },
          messageBody,
          commentId,
        }),
      ),
  },
});

type InputProps = {
  orgId: number;
  employeeId: number;
};

type ReduxProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & ReduxProps & DispatchProps;

export const EmployeeCommentList = connect(
  mapStateToProps,
  mapDispatchToProps,
)(({ orgId, employeeId, comments, commentsState, commentDraft, actions }: Props) => {
  useEffect(() => {
    actions.loadComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentsState]);

  const handleSelectCommentTemplate = (templateMessage: string) =>
    actions.autosaveDraft(templateMessage);

  return (
    <div>
      <CommentList
        idKey={employeeId}
        profileType="employee"
        comments={comments}
        saveComment={actions.saveComment}
        editComment={actions.editComment}
        deleteComment={actions.deleteComment}
        saveDraft={actions.autosaveDraft}
        clearDraft={actions.clearSavedDraft}
        commentDraft={commentDraft}
      />
      <EmployeeCommentTemplates
        orgId={orgId}
        employeeId={employeeId}
        onSelect={handleSelectCommentTemplate}
      />
    </div>
  );
});
